<div class="row">
    <div class="col-md-6 offset-md-3 mt-4">
        <h3>Login</h3>
        <form>
            <div class="form-group">
              <label for="loginUserName">Username</label>
              <input type="text" class="form-control" id="loginUserName" placeholder="Username">
            </div>
            <div class="form-group">
              <label for="loginPw">Password</label>
              <input type="password" class="form-control" id="loginPw">
            </div>
            <div class="form-group form-check">
                <a routerLink="reset-password" >Forgot password</a>

            </div>
            <button type="submit" class="btn btn-primary">Login <i class="fas fa-sign-in-alt"></i></button>
          </form>
    </div>
</div>
